import { putUser } from '../index';

export const editUser = (id, data) => {
  return putUser(id, data);
};